import type { Components } from "react-markdown";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

export const P: Components["p"] = ({ children, className, ...rest }) => (
  <p className={cn("af-pt-4 af-text-sm", className)} {...rest}>
    {children}
  </p>
);
